import TextAnalogyQuestion from './TextAnalogyQuestion.vue';
export default {
  name: "TextLogicalReasoningQuestion",
  components: {
    TextAnalogyQuestion
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G']
    };
  },
  computed: {
    isAnalogy() {
      return this.question.contentMode === 'VERBAL_ANALOGY';
    }
  },
  methods: {
    init() {},
    parseImages(value) {
      if (Array.isArray(value)) return value;
      try {
        return JSON.parse(value || '[]');
      } catch (e) {
        return [];
      }
    }
  },
  mounted() {
    this.init();
  }
};